/* @flow */
import React from 'react';
import CashboxesPanel from './CashboxesPanel'

class CalculateCashboxes extends React.Component {
    render() {
        return <CashboxesPanel />
    }
}

export default CalculateCashboxes;



// WEBPACK FOOTER //
// ./src/browser/menu/report/cashboxes/CalculateCashboxes.js